export default __webpack_public_path__ + "847b95bd90f709290b04678d5ffd9fa9.wasm";